import { toast } from "react-toastify";
import { api } from "../../api";
import { observable } from "mobx";
import axios from "axios";
import { LoginStore } from "../login/LoginStore";

export class _GenerateStore {

    obs = observable({
        open_2fa: false as boolean,
        codeBackup: [] as any,
        openCadastra2fa: false as boolean,
        open2fa: false as boolean
    })

    async handleGenerateCode() {
        try {
            let resp = await api.get('/api/2fa/generate')

            toast.success('QR Code gerado!', {});
            return [resp.data.cod, resp.data.manual]
        } catch (ex) {
            toast.error('Erro ao gerar QR Code, tente novamente mais tarde!', {});
            return ""
        }
    }

    async handleEditCode(status: boolean) {

        try {
            let data = { "status": status }

            let resp = await api.post('/api/2fa/status', data)

            if (resp.data.ok) {
                return true
            } else {
                toast.error(resp.data.msg, {});
                return false
            }
        } catch (ex) {
            toast.error('Erro na request, tente novamente mais tarde!', {});
            return false
        }
    }

    async handleGenerateCodeBackup() {

        try {
            let resp = await api.get('/api/2fa/generate/backup')
            toast.success('Códigos de Backup gerados com sucesso!', {});

            return resp.data.bkpcodes
        } catch (ex) {
            return []
        }
    }

    async handleValidateInitialCode(cod: string): Promise<boolean> {

        try {
            let data = { "cod": cod }

            let resp = await api.post('/api/2fa/validate', data)

            if (resp.data.ok) {
                toast.success("Código validado com sucesso!", {});
                this.obs.codeBackup = resp.data.bkpcodes
                return false

            } else {
                toast.error("Código inválido!", {});
                return true
            }

        } catch (ex) {
            toast.error("Ocorreu um erro, tente novamente mais tarde!", {});
            return true
        }
    }

    async handleGetStatus(): Promise<any> {

        try {
            let resp = await api.get('/api/2fa/status')
            if (resp.data.ok) {
                return resp.data
            } else {
                toast.error(resp.data.msg, {});
                return false
            }
        } catch (ex) {
            toast.error("Ocorreu um erro, tente novamente mais tarde!", {});
            return false
        }

    }

    async handleGeneratePublicCode(tokenUser: string) {
        try {
            let resp = await axios.get(`/api/2fa/generate`, { headers: { 'X-NZ-Token': tokenUser } })
            return [resp.data.cod, resp.data.manual]
        } catch (ex) {
            toast.error('Erro ao gerar QR Code, tente novamente mais tarde!', {});
            return ""
        }
    }

    async handlePublicValidateInitialCode(cod: string, tokenUser: string): Promise<boolean> {

        try {
            let data = { "cod": cod }

            let resp = await axios.post('/api/2fa/validate', data, { headers: { 'X-NZ-Token': tokenUser } })

            if (resp.data.ok) {
                toast.success("Código Validado!", {});

                this.obs.codeBackup = resp.data.bkpcodes
                return false

            } else {
                toast.error("Código inválido!", {});
                return true
            }

        } catch (ex) {
            toast.error("Ocorreu um erro, tente novamente mais tarde!", {});
            return true
        }
    }
}

export const GenerateStore = new _GenerateStore();
